import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalPhoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_phone"}/>
}
